export function newExpiresAtDate(addMonth: number): Date {
  const expirationDate = new Date();
  expirationDate.setMonth(expirationDate.getMonth() + addMonth);

  return expirationDate;
}
